query GetUtmParameters {
  utmParameters {
    utmSource {
      value
      count
    }
    utmMedium {
      value
      count
    }
    utmCampaign {
      value
      count
    }
    utmTerm {
      value
      count
    }
    utmContent {
      value
      count
    }
  }
}